import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';

import { makeAPIRequestReactQueryWithHeaders } from '../api';

export interface PracticeProvider {
  id: string;
  firstName: string;
  lastName: string;
  nationalProviderId: string;
}

/**
 * Fetches providers for the current practice that have a National Provider ID.
 * Used to populate the dentist dropdown in the verification form.
 */
export const usePracticeProviders = () => {
  const {
    primaryPracticeId: practiceId,
    primaryOrganizationId: organizationId,
  } = useSelector(
    (state: {
      login: {
        user: {
          primaryPracticeId?: string;
          primaryOrganizationId?: string;
        };
      };
    }) => state.login.user,
  );

  return useQuery<PracticeProvider[]>(
    ['practiceProviders', practiceId],
    () =>
      makeAPIRequestReactQueryWithHeaders<PracticeProvider[]>(
        `practices/${practiceId}/providers`,
        { onlyWithNationalProviderId: true },
        {
          Org: organizationId,
          Practice: practiceId,
        },
        'GET',
      ),
    {
      enabled: Boolean(practiceId && organizationId),
      staleTime: 5 * 60 * 1000,
    },
  );
};
